import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import closeIcon from 'assets/svg/navigation/icon_close.svg';
import media from 'media';

const Wrapper = styled.div`
  position: absolute;
  width: 20rem;
  left: ${(props) => (props.alignX === 'right') && '50%'};
  right: ${(props) => (props.alignX === 'left') && '50%'};
  top: ${(props) => (props.alignY === 'bottom') && '50%'};
  bottom: ${(props) => (props.alignY === 'top') && '50%'};
  z-index: 2;
  white-space: normal;

  ${media.tablet`
    position: fixed;
    width: 95%;
    max-height: 95%;
    overflow-y: auto;
    top: auto;
    bottom: 0%;
    left: 0%;
  `}
`;
const Content = styled.div`
  box-sizing: border-box;
  padding: 1.25rem;
  background: white;
  box-shadow: 0 0 10px 8px rgba(0,0,0,0.08);
  text-align: left;
  cursor: auto;

  ${media.tablet`
    padding: 1rem;
  `}
`;

const H1 = styled.h1`
  background: white;
  font-size: 1.25rem;
  margin: 0 0 1rem 0;
`;
const P = styled.p`
  font-size: 1rem;
  margin: 0 0 1rem 0;
`;
const A = styled.a`
  font-size: 1rem;
  margin: 4rem 0;
  color: #1C7EA7;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
const CloseButton = styled.button`
  display: none;
  float: right;
  background: none;
  border: none;
  width: 2rem;
  height: 2rem;
  font-weight: bold;
  ${media.tablet`
    display: block;
  `}
`;


class Infopanel extends Component {
  handleClick = (event) => {
    event.stopPropagation();
  }
  render() {
    const { title, description, link, alignX, alignY } = this.props;
    return (
      <Wrapper alignX={alignX} alignY={alignY} onClick={this.handleClick}>
        <Content>
          <CloseButton onClick={this.props.onClose}><img src={closeIcon} alt="close" /></CloseButton>
          <H1>{title}</H1>
          <P>{description}</P>
          <A href={link.url} target="_blank">{link.title}</A>
        </Content>
      </Wrapper>
    );
  }
}

Infopanel.propTypes = {
  alignX: PropTypes.string.isRequired,
  alignY: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

Infopanel.defaultProps = {
  link: null,
};

export default Infopanel;



// WEBPACK FOOTER //
// ./src/components/Infopanel/Infopanel.js